export default function announcementBar(speed, slides) {
  return {
    slide: 0,
    containerHeight: 0,
    visible: true,

    init() {
      this.startSlideRotation();
      this.calculateHeight();
    },

    calculateHeight() {
      const barElement = this.$refs.announcementBar;
      if (!barElement) return;

      const updateHeight = (() => {
        let timeout;
        return () => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            const height = barElement.offsetHeight;
            const currentHeight = parseInt(
              document.documentElement.style.getPropertyValue("--announcement-bar-height"),
              10
            );
            if (height !== currentHeight) {
              document.documentElement.style.setProperty("--announcement-bar-height", `${height}px`);
              this.containerHeight = height;
            }
          }, 100);
        };
      })();

      updateHeight();
      const resizeObserver = new ResizeObserver(updateHeight);
      resizeObserver.observe(barElement);
      this.$cleanup = () => resizeObserver.disconnect();
    },

    startSlideRotation() {
      setInterval(() => {
        this.slide = this.slide < slides - 1 ? this.slide + 1 : 0;
      }, speed * 1000);
    },

    toggle() {
      this.visible = false;
    }
  };
}
